import React from "react";
import "./testimonials.css";
import AVT1 from "../../assets/avatar1.png";
import AVT2 from "../../assets/avatar2.png";
import AVT3 from "../../assets/avatar3.jpeg";
import AVT4 from "../../assets/avatar4.jpeg";
//Swiper API
// import required modules
import { EffectCube, Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/pagination";

const data = [
  {
    avatar: AVT1,
    name: "Theresa Robinson",
    review:
      "Incredibly professional and polite. I certainly got my money's worth. Let's stay in touch!",
  },
  {
    avatar: AVT2,
    name: "Michael Sheen",
    review:
      "I was on the fence at first, but you have crazy work ethic kid, will definitely be hearing from me again",
  },
  {
    avatar: AVT3,
    name: "Elijah Lewis",
    review: "All tasks finished in record time, wonderful job",
  },
  {
    avatar: AVT4,
    name: "Andnej Bartkowiak",
    review:
      "Thank you for an amazing service, game works perfectly. 5/5 from Poland",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Some Reviews From My Clients</h5>
      <h2>Testimonials</h2>
      <Swiper
        effect={"cube"}
        grabCursor={true}
        cubeEffect={{
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        }}
        pagination={{ clickable: true }}
        modules={[EffectCube, Pagination]}
        className="container container__testimonials mySwiper"
      >
        {data.map(({ review, avatar, name }, index) => {
          return (
            <SwiperSlide key={index}>
              <article className="testimonials">
                <div className="client__avatar">
                  <img src={avatar} alt="client image" />
                </div>
                <h5 className="client__name">{name}</h5>
                <small className="client__review">{review}</small>
              </article>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
